<template>

    <FloatingPanel>

        <div class="common-canvas-blocks-custom-category-admin-BlockPanel">

            <Tabs :tabs="[
                'General',
                'Filters',
                'Custom',
            ]">

                <div slot="General">

                    <div class="tw-px-4 tw-py-3 text">

                        <div class="tw-mb-1 tw-text-gray-600 label">Anchor (link within page)</div>

                        <input
                            type="text"
                            class="form-control"
                            @input="$set(options, 'anchor', $event.target.value)"
                            placeholder="categorie"
                            :value="options.anchor"/>

                    </div>

                    <div class="tw-px-4 tw-py-3 text">

                        <div class="tw-mb-1 tw-text-gray-600 label">Spacing (top and bottom)</div>

                        <select
                            class="form-control"
                            @input="$set(options, 'marge', $event.target.value)"
                            v-model="options.marge">
                            <option v-for="option in marge" :value="option.value">{{ option.text }}</option>
                        </select>

                    </div>

                    <div class="tw-px-4 tw-py-3 colors">

                        <div class="tw-mb-1 tw-text-gray-600 label">Background color</div>

                        <button
                            v-for="color in colors"
                            :style="{ background: color }"
                            class="tw-w-8 tw-h-8 tw-border tw-border-gray-400 tw-inline-block tw-m-1 tw-shadow-sm tw-cursor-pointer color"
                            :class="{ selected: color == currentColor }"
                            @click="setColor(color)"/>

                    </div>

                </div>

                <div slot="Filters">

                    <div class="tw-px-4 tw-py-3 text">

                        <div class="tw-mb-1 tw-text-gray-600 label">Select content type</div>

                        <v-select
                            :options="content_types"
                            v-model="options.content_type">

                            <div slot="no-options">No options</div>

                        </v-select>

                    </div>

                    <div class="tw-px-4 tw-py-3 text">

                        <div class="tw-mb-1 tw-text-gray-600 label">Select theme</div>

                        <v-select
                            :options="themes"
                            label="name"
                            v-model="options.theme_id"
                            :reduce="form => form.id">

                            <div slot="no-options">No options</div>

                        </v-select>

                    </div>

                </div>

                <div slot="Custom">

                    <div class="tw-px-4 tw-py-3 text">

                        <div class="tw-mb-1 tw-text-gray-600 label">Amount of columns</div>

                        <v-select
                            :options="[
                                1, 2, 3, 4
                            ]"
                            v-model="options.columns">

                            <div slot="no-options">No options</div>

                        </v-select>

                    </div>


                    <SwitchInput
                        label="Skip items from a previous block?"
                        instruction="Choose &quot;yes&quot; to let this block skip items which are shown in the first previous sibling of this type of block."
                        :options="options"
                        options-property="skip"
                        :items="[{
                            	label: 'Yes',
                            	value: 1,
                            }, {
                            	label: 'No',
                            	value: 0,
                            }]"
                        :default-value="0"
                    />

                    <div class="tw-px-4 tw-py-3 text">

                        <div class="tw-mb-1 tw-text-gray-600 label">Keep loading elements?</div>

                        <v-select
                            :options="[
                                    {
                                        'label': 'Yes',
                                        'value': 1,
                                    },
                                    {
                                        'label': 'No',
                                        'value': 0,
                                    }
                                ]"
                            v-model="options.keeploading">

                            <div slot="no-options">No options</div>

                        </v-select>

                    </div>

                    <div class="tw-px-4 tw-py-3 text">

                        <div class="tw-mb-1 tw-text-gray-600 label">Slider mobile?</div>
                        <!--                <small class="tw-text-gray-400">You can use this to skip a few items (in case you want to continue the last block or something like that)</small>-->

                        <v-select
                            :options="[
                                    {
                                        'label': 'Yes',
                                        'value': 1,
                                    },
                                    {
                                        'label': 'No',
                                        'value': 0,
                                    }
                                ]"
                            v-model="options.slider">

                            <div slot="no-options">No options</div>

                        </v-select>

                    </div>

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/AbstractPanel";
import FloatingPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/panels/FloatingPanel";
import Tabs from "@galaxy/js/common/canvas/editor/canvas/document/editors/panels/Tabs";
import axios from 'axios';
import SwitchInput
    from "../../../../../../../../packages/lav-galaxy/framework/resources/js/common/canvas/editor/canvas/document/editors/inputs/SwitchInput";

export default {

    extends: AbstractPanel,

    components: {
        SwitchInput,
        FloatingPanel,
        Tabs,
    },

    data() {
        return {
            colors: [
                '#fff',
                '#00000008',
            ],
            marge: [
                {
                    'text': 'Geen',
                    'value': '',
                },
                {
                    'text': 'Klein',
                    'value': 'tw-py-2 md:tw-py-4',
                },
                {
                    'text': 'Middel',
                    'value': 'tw-py-4 md:tw-py-8',
                },
                {
                    'text': 'Groot',
                    'value': 'tw-py-6 md:tw-py-14',
                },
            ],
            content_types: [
                'News',
                'Training',
                'Video',
                'Webinar',
                'Whitepaper',
                'Channel',
                'Blog',
            ],
            themes: [],
        };
    },

    created() {
        this.loadThemes();
    },

    methods: {

        setColor(color) {
            // Set
            this.$set(this.options, 'color', color);
        },

        async loadThemes() {
            // Load artists.
            this.themes = (await axios.get(this.adminUrlPrefix + '/themes')).data;
        },

    },

    computed: {

        currentColor() {
            return this.options.color;
        },

    }

}

</script>

<style lang="scss" scoped>

.common-canvas-blocks-custom-category-admin-BlockPanel {

}

</style>
